<template>
  <div class="introduction">
    <div class="title">企业简介</div>
    <div class="txt">
      <img :src="introduction.imgUrl" align="right" hspace="20" vspace="20" />
      {{ introduction.tip1 }}
    </div>
    <div class="txt" v-for="(item, index) in introduction.tip2" :key="index">
      {{ item }}
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      introduction: {},
    };
  },
  methods: {
    reqIntroduction() {
      axios.get("./data.json").then((res) => {
        this.introduction = res.data.introduction;
      });
    },
  },
  mounted() {
    this.reqIntroduction();
  },
};
</script>

<style scoped>
img {
  width: 40%;
}
.title {
  font-size: 28px;
  text-align: center;
  padding: 20px 0;
}
.txt {
  text-indent: 2em;
  line-height: 35px;
  word-wrap: break-word;
}
</style>
